<template>
    <pg-page title="Private Gym - Prijzen"
             :header="header"
             id="prijzen"
    >

        <div class="row">
            <div class="col"></div>
            <div class="col col-md-4">
                <a class="btn btn-primary w-100 btn btn-lg btn-primary" href="/abonnementen">
                    <i :class="'fa-solid fa-chevron-right me-2 deze2'"></i> Klik hier om naar de abonnementen pagina te gaan
                </a>
            </div>
            <div class="col"></div>
<!--            <div class="col-lg-5 col-md-12 mb-4">-->
<!--                <div class="price-card h-100 shadow-lg p-4">-->
<!--                    <div class="card-body">-->
<!--                        <div class="text-center p-3">-->
<!--                            <h5 class="card-title">Private Gym</h5>-->
<!--&lt;!&ndash;                            <small>Individual</small>&ndash;&gt;-->
<!--                            <br/>-->
<!--                            <span class="h1">€{{ roundPrice(final4WeekPrice / 4) }}</span> / wk-->
<!--                            <br/>-->
<!--                            <small v-if="finalOneOffPrice">+ €{{finalOneOffPrice}} eenmalig</small>-->
<!--                            <br>-->
<!--                        </div>-->
<!--                        <p class="card-text">-->
<!--                            Bij ieder abonnement krijg je onderstaande voordelen. Deze kun je nog uitbreiden met <em>Personal Training</em> en een <em>Stok achter de deur</em>-->
<!--                        </p>-->
<!--                    </div>-->
<!--                    <ul class="list-group list-group-flush">-->
<!--                        <li class="list-group-item"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">-->
<!--                            <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>-->
<!--                        </svg> Onbeperkt reserveren / trainen</li>-->
<!--                        <li class="list-group-item"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">-->
<!--                            <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>-->
<!--                        </svg> 24/7 Toegang </li>-->
<!--                        <li class="list-group-item"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">-->
<!--                            <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>-->
<!--                        </svg> Altijd een eiland voor jezelf</li>-->
<!--                        <li class="list-group-item"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">-->
<!--                            <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>-->
<!--                        </svg> Schema's in de app</li>-->
<!--                        <li class="list-group-item"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">-->
<!--                            <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>-->
<!--                        </svg> Anti-sponsor garantie</li>-->
<!--                    </ul>-->

<!--                    <sign-up-button :attach-to-existing-account="attach" class="d-none d-lg-block mt-4"></sign-up-button>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="col-lg-7 col-md-12 mb-4 order-lg-first">-->
<!--                <div class="card shadow-lg mb-4">-->
<!--                    <div class="card-header">-->
<!--                        <div class="d-flex">-->
<!--                            <div>Looptijd</div>-->
<!--                            <div class="ms-auto"><a href="" @click.prevent="showLooptijdModal = true">Meer info</a></div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="card-body">-->
<!--                        <modal title="Looptijd" v-if="showLooptijdModal" @closed="showLooptijdModal = false">-->
<!--                            <em>-->
<!--                                <p>-->
<!--                                    Weet je nog niet of Private Gym bij je gaat passen? Probeer het dan een maand. Ben je al overtuigd? Gun jezelf dan 12 maanden en krijg een techniek training + tas cadeau.-->
<!--                                </p>-->
<!--                                <ul>-->
<!--                                    <li>Altijd maandelijks opzegbaar na de looptijd</li>-->
<!--                                    <li>In overleg is veel mogelijk en kan een abonnement ook even tijdelijk op pauze voor een vakantie / sabattical</li>-->
<!--                                </ul>-->
<!--                            </em>-->
<!--                        </modal>-->
<!--                        <div class="form-check">-->
<!--                            <input class="form-check-input" type="radio" name="looptijd" id="looptijd1Maand"-->
<!--                                   @click="looptijd = 1" :checked="(looptijd === 1)">-->
<!--                            <label class="form-check-label" for="looptijd1Maand">-->
<!--                                Minimaal 1 maand <em class="ms-4 d-block d-sm-inline"><small>+ €{{roundPrice(looptijdExtraPrice[1] / 4)}} / week</small></em>-->
<!--                            </label>-->
<!--                        </div>-->
<!--                        <div class="form-check">-->
<!--                            <input class="form-check-input" type="radio" name="looptijd" id="looptijd12Maand"-->
<!--                                   @click="looptijd = 12" :checked="(looptijd === 12)">-->
<!--                            <label class="form-check-label" for="looptijd12Maand">-->
<!--                                Minimaal 12 maanden <em class="ms-4 d-block d-sm-inline"><small>+ Gratis techniektraining & luxe sporttas</small></em>-->
<!--                            </label>-->
<!--                        </div>-->
<!--                        <div class="form-check">-->
<!--                            <input class="form-check-input" type="radio" name="looptijd" id="looptijd24Maand"-->
<!--                                   @click="looptijd = 24" :checked="(looptijd === 24)"-->
<!--                            >-->
<!--                            <label class="form-check-label" for="looptijd24Maand">-->
<!--                                Minimaal 24 maanden <em class="ms-4 d-block d-sm-inline"><small>+ 7,5% korting</small></em>-->
<!--                            </label>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="card shadow-lg my-4">-->
<!--                    <div class="card-header">-->
<!--                        <div class="d-flex">-->
<!--                            <div>Personal training</div>-->
<!--                            <div class="ms-auto"><a href="" @click.prevent="showPersonalTrainingModal = true">Meer info</a></div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="card-body">-->
<!--                        <modal title="Personal training" v-if="showPersonalTrainingModal" @closed="showPersonalTrainingModal = false">-->
<!--                            <em>-->
<!--                                <p>-->
<!--                                        Soms is het fijn te wisselen van schema. Te kunnen sparren met een professional. Of feedback te krijgen op je techniek. Wat zelfverzekerder worden. De ene periode een schema voor een betere conditie. De andere periode focus op kracht. Misschien heb je een blessure? Of wil je hulp bij voeding? Plezier vinden in trainen?-->
<!--                                </p>-->
<!--                                <p>-->
<!--                                    Voor ieder wat wils. Maar altijd met 100% focus op jou en jouw doelen. Een investering in jezelf. De perfecte oplossing voor als je wat over hebt voor je gezondheid.-->
<!--                                </p>-->
<!--                                <ul>-->
<!--                                    <li><strong>Techniek training:</strong> focus op zelfstandigheid en zelfvertrouwen. Na één sessie zelfstandig aan de slag met 2 schema's</li>-->
<!--                                    <li><strong>Doorlopende personal training:</strong> meer maatwerk, afwisseling en ruimte voor focus op mindset & voeding</li>-->
<!--                                </ul>-->
<!--                                <p>-->
<!--                                    <strong>"If you pay peanuts, you get monkeys"</strong> - en dat geldt zeker voor personal training.-->
<!--                                    Bij Private Gym betaal je voor kwaliteit. En mag je kwaliteit verwachten.-->
<!--                                </p>-->
<!--                            </em>-->
<!--                        </modal>-->
<!--                        <div class="form-check">-->
<!--                            <input class="form-check-input" type="radio" name="ptFrequentie" id="ptGeen"-->
<!--                                   @click="personalTraining = 0" :checked="(personalTraining == 0)">-->
<!--                            <label class="form-check-label" for="ptGeen">-->
<!--                                Geen, enkel vrije training-->
<!--                            </label>-->
<!--                        </div>-->
<!--                        <div class="form-check">-->
<!--                            <input class="form-check-input" type="radio" name="ptFrequentie" id="pt1Keer"-->
<!--                                   @click="personalTraining = 'eenmalig'" :checked="(personalTraining === 'eenmalig')">-->
<!--                            <label class="form-check-label" for="pt1Keer">-->
<!--                                Techniek training <em class="ms-4 d-block d-sm-inline"><small>+ €{{techniekTrainingPrijs}} / eenmalig</small></em>-->
<!--                            </label>-->
<!--                        </div>-->
<!--&lt;!&ndash;                        <div class="form-check">&ndash;&gt;-->
<!--&lt;!&ndash;                            <input class="form-check-input" type="radio" name="ptFrequentie" id="pt1xPer4weken"&ndash;&gt;-->
<!--&lt;!&ndash;                                   @click="personalTraining = 1" :checked="(personalTraining === 1)">&ndash;&gt;-->
<!--&lt;!&ndash;                            <label class="form-check-label" for="pt1xPer4weken">&ndash;&gt;-->
<!--&lt;!&ndash;                                Iedere 4 weken <em class="ms-4 d-block d-sm-inline"><small>+ €{{roundPrice(personalTrainingPrijs / 4)}} / week</small></em>&ndash;&gt;-->
<!--&lt;!&ndash;                            </label>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--                        <div class="form-check">-->
<!--                            <input class="form-check-input" type="radio" name="ptFrequentie" id="ptCustomCheck"-->
<!--                                   @click="personalTraining = 1" :checked="(personalTraining > 0)">-->
<!--                            <input type="number" name="ptFrequentie" id="ptCustom"-->
<!--                                   style="width: 36px;"-->
<!--                                   v-model="personalTraining"><span class="me-2"> x</span>-->
<!--                            <label class="form-check-label d-inline" for="ptCustom">-->
<!--                                per 4 weken <em class="ms-4 d-block d-sm-inline"><small>+ €{{ personalTrainingPrijs > 0 ? roundPrice(personalTrainingPrijs / 4) : roundPrice(personalTrainingBasePrijs / 4) }} / week</small></em>-->
<!--                            </label>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="card shadow-lg my-4">-->
<!--                    <div class="card-header">-->
<!--                        <div class="d-flex">-->
<!--                            <div>Stok achter de deur</div>-->
<!--                            <div class="ms-auto"><a href="" @click.prevent="showStokAchterDeDeurModal = true">Meer info</a></div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="card-body">-->
<!--                        <modal title="Stok achter de deur" v-if="showStokAchterDeDeurModal" @closed="showStokAchterDeDeurModal = false">-->
<!--                                <em>-->
<!--                            <p>-->
<!--                                    Voor wat extra motivatie kun je kiezen voor een stok achter de deur. Je betaald 2x zoveel. Je kiest een minimaal aantal keer dat jij per week wil trainen. En als je jouw week target haalt, krijg je de helft weer terug!-->
<!--                            </p>-->
<!--                            <ul>-->
<!--                                <li>-->
<!--                                    Als je wat achter loopt op je targets contacten we je even-->
<!--                                </li>-->
<!--                                <li>-->
<!--                                    Je kunt dit 8 weken per jaar pauzeren (of vaker indien nodig)-->
<!--                                </li>-->
<!--                                <li>-->
<!--                                    Het gaat om het gemiddelde over een periode van 4 weken-->
<!--                                </li>-->
<!--                                <li>-->
<!--                                    Je krijgt je bedrag ook per 4 weken terug-->
<!--                                </li>-->
<!--                                <li>-->
<!--                                    Wij kunnen dit altijd permanent uitzetten. Je hoeft alleen maar even te bellen. Nog een extra stok achter de deur ;-)-->
<!--                                </li>-->
<!--                            </ul>-->
<!--                                </em>-->
<!--                        </modal>-->
<!--                        <div class="form-check">-->
<!--                            <input class="form-check-input" type="radio" name="stokAchterDeDeur" id="stokNee"-->
<!--                                  @click="stokAchterDeDeur = 0" :checked="(stokAchterDeDeur === 0)">-->
<!--                            <label class="form-check-label" for="stokNee">-->
<!--                                Nee-->
<!--                            </label>-->
<!--                        </div>-->
<!--&lt;!&ndash;                        <div class="form-check">&ndash;&gt;-->
<!--&lt;!&ndash;                            <input class="form-check-input" type="radio" name="stokAchterDeDeur" id="stok2Keer"&ndash;&gt;-->
<!--&lt;!&ndash;                                   @click="stokAchterDeDeur = 2" :checked="(stokAchterDeDeur === 2)">&ndash;&gt;-->
<!--&lt;!&ndash;                            <label class="form-check-label" for="stok2Keer">&ndash;&gt;-->
<!--&lt;!&ndash;                                2 of meer keer per week trainen <em class="ms-4 d-block d-sm-inline"><small>+ 200%</small></em>&ndash;&gt;-->
<!--&lt;!&ndash;                            </label>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="form-check">&ndash;&gt;-->
<!--&lt;!&ndash;                            <input class="form-check-input" type="radio" name="stokAchterDeDeur" id="stok3Keer"&ndash;&gt;-->
<!--&lt;!&ndash;                                   @click="stokAchterDeDeur = 3" :checked="(stokAchterDeDeur === 3)">&ndash;&gt;-->
<!--&lt;!&ndash;                            <label class="form-check-label" for="stok3Keer">&ndash;&gt;-->
<!--&lt;!&ndash;                                3 of meer keer per week trainen <em class="ms-4 d-block d-sm-inline"><small>+ 200%</small></em>&ndash;&gt;-->
<!--&lt;!&ndash;                            </label>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--                        <div class="form-check">-->
<!--                            <input class="form-check-input" type="radio" name="stokAchterDeDeur" id="stokCustomRadio"-->
<!--                                   @click="stokAchterDeDeur = 1" :checked="(stokAchterDeDeur > 0)">-->
<!--                            <input type="number" name="stokAchterDeDeur" id="stokCustom" class="me-2"-->
<!--                                   style="width: 36px;"-->
<!--                                   v-model="stokAchterDeDeur">-->
<!--                            <label class="form-check-label d-inline" for="ptCustom">-->
<!--                                of meer keer ga ik per week trainen <em class="ms-4 d-block d-sm-inline"><small>+ 200%</small></em>-->
<!--                            </label>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->



<!--                <div class="card shadow-lg my-4">-->
<!--                    <div class="card-header bg-success text-white" style="border-radius: 0.25rem;">-->
<!--                        <div class="d-flex">-->
<!--                            <div>-->
<!--                                <strong>-->
<!--                                    <i class="bi bi-shield-fill-check"></i> <em>-->
<!--                                        De Private Gym Anti-sponsor Garantie-->
<!--                                    </em>-->
<!--                                </strong>-->
<!--                            </div>-->
<!--                            <div class="ms-auto"><a class="text-white" href="" @click.prevent="showAntiSponsorGarantieModal = true">Meer info</a></div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <modal title="De Anti-sponsor Garantie" v-if="showAntiSponsorGarantieModal" @closed="showAntiSponsorGarantieModal = false">-->
<!--                        <p>-->
<!--                            Jij schrijft je in omdat je wil sporten. Wij hebben een mooie gym neergezet in de hoop dat jij <em>komt</em>  sporten. Sporten frictieloos en leuk maken. Dat is de missie van Private Gym.-->
<!--                        </p>-->
<!--                        <p>-->
<!--                            Maar, als jij op welk punt dan ook niet graag meer komt. Of het niet meer leuk vindt;-->
<!--                            Ongeacht de looptijd.-->
<!--                            Kun je altijd met ons in gesprek.-->
<!--                            Wij zullen ons best doen je te motiveren en handvaten aan te reiken om je weer met plezier naar de gym te krijgen.-->
<!--                            Want we gaan er vanuit dat je je inschrijft omdat je wel graag <em>wil</em> sporten.-->
<!--                        </p>-->
<!--                        <p>-->
<!--                            Maar je wil natuurlijk geen gym sponsor worden.-->
<!--                            Dus als niets lukt, of het leven even anders loopt bedenken we een oplossing zodat jij nooit gym sponsor hoeft te worden.-->
<!--                        </p>-->
<!--                        <p>-->
<!--                            Dat is onze <em>Anti-sponsor garantie</em>-->
<!--                        </p>-->
<!--                    </modal>-->
<!--&lt;!&ndash;                    <div class="card-body">&ndash;&gt;-->
<!--&lt;!&ndash;                            <div class="form-check">&ndash;&gt;-->
<!--&lt;!&ndash;                                <input class="form-check-input" type="radio" name="stokAchterDeDeur" id="stokNee"&ndash;&gt;-->
<!--&lt;!&ndash;                                       @click="stokAchterDeDeur = 0" :checked="(stokAchterDeDeur === 0)">&ndash;&gt;-->
<!--&lt;!&ndash;                                <label class="form-check-label" for="stokNee">&ndash;&gt;-->
<!--&lt;!&ndash;                                    Nee&ndash;&gt;-->
<!--&lt;!&ndash;                                </label>&ndash;&gt;-->
<!--&lt;!&ndash;                            </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--                </div>-->
<!--                <div class="card shadow-lg mb-0 d-block d-lg-none">-->
<!--                    <sign-up-button :attach-to-existing-account="attach"></sign-up-button>-->
<!--                </div>-->
<!--            </div>-->
        </div>
    </pg-page>
</template>

<script>

import PgPage from "../Components/PgPage";
import ContactModal from "../Components/Contact/ContactModal";
import Modal from "../Components/Modal";
import SignUpButton from "../Components/Prijzen/SignUpButton";
export default {
    components: {
        SignUpButton,
        Modal,
        ContactModal,
        PgPage
    },

    props:{
        attach: {default: false}, // This one turns it into an "attach" form that redirects the user elsewhere on "Word nu lid"
    },

    mixins: [],

    data: function () {
        return {
            showFormModal: false,

            looptijd: 12,
            personalTraining: 0, // eenmalig, 0, 1+
            stokAchterDeDeur: 0, //

            looptijdExtraPrice: {
                1: 12.00,
                12: 0,
                24: -3.00,
            },

            showStokAchterDeDeurModal: false,
            showPersonalTrainingModal: false, // 0, 'eenmalig', 1, X
            showLooptijdModal: false,
            showAntiSponsorGarantieModal: false,
        };
    },

    computed: {
        header() {
          return this.attach ? 'Abonnement koppelen' : 'Prijzen';
        },
        techniekTrainingPrijs() {
            return this.looptijd >= 12 ? 0 : '59,99';
        },
        personalTrainingBasePrijs() {
            return this.looptijd < 24 ? 59.99 : 53.99;
        },
        personalTrainingPrijs() {
            if(this.personalTraining === 'eenmalig' || this.personalTraining == 0) {
                return 0;
            }
            return Math.round((this.personalTrainingBasePrijs * this.personalTraining + Number.EPSILON) * 100) / 100;
        },

        final4WeekPrice() {
            let basePrice = 39.99;

            basePrice = basePrice + this.looptijdExtraPrice[this.looptijd];

            basePrice = basePrice + this.personalTrainingPrijs;

            if(this.stokAchterDeDeur > 0) {
                basePrice = basePrice * 2;
            }

            return Math.round((basePrice + Number.EPSILON) * 100) / 100
        },
        finalOneOffPrice() {
            let basePrice = 0;
            if(this.personalTraining === 'eenmalig' && this.looptijd === 1) {
                basePrice = basePrice + 59.99;
            }
            return basePrice;
        }
    },

    created() {

    },

    mounted() {
        // if(localStorage.getItem('subscription_looptijd') === null) {
        //
        //     if(this.looptijd === 1) {
        //         this.personalTraining = 0;
        //     }
        // }


        if(localStorage.getItem('subscription_personalTraining') !== null) {
            this.personalTraining = localStorage.getItem('subscription_personalTraining');
        }
        else {
            localStorage.setItem('subscription_personalTraining', 0);
            this.personalTraining = 0; // voor de Watcher
        }

        if(localStorage.getItem('subscription_looptijd') !== null) {
            this.looptijd = parseInt(localStorage.getItem('subscription_looptijd'));
        }
        else {
            localStorage.setItem('subscription_looptijd', 12);
            this.looptijd = 12; // voor de Watcher
            this.personalTraining = 'eenmalig';
        }

        if(localStorage.getItem('subscription_stokAchterDeDeur') !== null) {
            this.stokAchterDeDeur = parseInt(localStorage.getItem('subscription_stokAchterDeDeur'));
        }
        else {
            localStorage.setItem('subscription_stokAchterDeDeur', 0);
            this.stokAchterDeDeur = 0; // voor de Watcher
        }

        // This one last, as it should be set after the others
        localStorage.setItem('subscription_price', this.roundPrice(this.final4WeekPrice / 4));
    },

    methods: {
        signup() {

        },
        roundPrice(number) {
            let priceNumber = Math.round((number - 0.01 + Number.EPSILON) * 100) / 100;
            let price = priceNumber.toString();

            let priceSuffix = '00';
            if(price.includes('.')) {
                let priceParts = price.split('.');
                priceParts[1] = priceParts[1].padEnd(2, '0');
                price = priceParts[0] + '.' + priceParts[1];
            }
            else {
                price = price + '.' + priceSuffix;
            }
            return price.replace('.', ',');
        }
    },

    watch: {
        looptijd: {
            handler(value) {
                localStorage.setItem('subscription_looptijd', value);
                localStorage.setItem('subscription_price', this.roundPrice(this.final4WeekPrice / 4));
            }
        },
        personalTraining: {
            handler(value) {
                localStorage.setItem('subscription_personalTraining', value);
                localStorage.setItem('subscription_price', this.roundPrice(this.final4WeekPrice / 4));
            }
        },
        stokAchterDeDeur: {
            handler(value) {
                localStorage.setItem('subscription_stokAchterDeDeur', value);
                localStorage.setItem('subscription_price', this.roundPrice(this.final4WeekPrice / 4));
            }
        }
    }
};
</script>

<style lang="scss" scoped>
    .price-card {
        border:none;
        //padding: 10px 50px;
        background-color: white;
    }

    .price-card::after {
        position: absolute;
        z-index: -1;
        opacity: 0;
        -webkit-transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
        transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
    }

    .price-card:hover::after {
        opacity: 1;
    }

    .price-card:hover .btn-outline-primary{
        color:white;
        background:#007bff;
    }
</style>
